import c from 'classnames'
import { FC } from 'react'
import { El, ElProps } from './El'
import styles from './FieldSet.module.scss'

export const FieldSet: FC<ElProps> = ({ children, className, ...props }) => (
  <El as={'fieldset'} {...props} className={c(styles.fieldset, className)}>{children}</El>
)
